import { Api, ConfigHelper } from 'relapp-api';

const routes = ConfigHelper.entityApiRoutes('2fa');

export default {
    /**
     *Check 2fa endpoint.
     *
     * @param {object} data
     *
     * @return {Promise}
     */
    check(data) {
        let route = routes['check'];

        return Api.post(route, data);
    },
    /**
     *Set 2fa endpoint.
     *
     * @return {Promise}
     */
    set() {
        let route = routes['set'];

        return Api.post(route);
    },
    /**
     *Reset 2fa endpoint.
     *
     * @return {Promise}
     */
    reset() {
        let route = routes['reset'];

        return Api.post(route);
    }
};
